import { createTheme } from "@mui/material/styles";
import { designTokens } from "./designTokens";

// Auth/onboarding theme — same neutral 60-30-10 palette as the logged-in app.
export const brandAuthTheme = createTheme({
  palette: {
    mode: "light",
    background: {
      default: designTokens.bgApp,
      paper: designTokens.bgSurface,
    },
    primary: {
      main: designTokens.primaryBrand,
      dark: designTokens.primaryHover,
      contrastText: designTokens.bgSurface,
    },
    secondary: {
      main: "#C2410C",
      contrastText: designTokens.bgSurface,
    },
    text: {
      primary: designTokens.textPrimary,
      secondary: designTokens.textMuted,
    },
    divider: designTokens.borderLight,
  },
  typography: {
    fontFamily: '"Source Sans 3", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    h1: { fontFamily: '"Lexend", sans-serif' },
    h2: { fontFamily: '"Lexend", sans-serif' },
    h3: { fontFamily: '"Lexend", sans-serif' },
    h4: { fontFamily: '"Lexend", sans-serif' },
    h5: { fontFamily: '"Lexend", sans-serif', fontWeight: 700, letterSpacing: "-0.01em" },
    h6: { fontFamily: '"Lexend", sans-serif' },
    button: { textTransform: "none", fontWeight: 600 },
  },
  shape: {
    borderRadius: 10,
  },
  components: {
    MuiLink: {
      defaultProps: { fontSize: 16 },
      styleOverrides: {
        root: { color: designTokens.primaryBrand, fontWeight: 600 },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: { borderRadius: 8 },
        notchedOutline: { borderColor: designTokens.borderLight },
      },
    },
    MuiButton: {
      styleOverrides: {
        containedPrimary: {
          boxShadow: "none",
          "&:hover": { boxShadow: "none", backgroundColor: designTokens.primaryHover },
        },
      },
    },
  },
});

export default brandAuthTheme;
